module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-24-4a8a909705f38a45c9ad6973e26b8b24.jpg";